export default {
  AUTH: {
    DANG_NHAP: "/auth/login",
    REFRESH_TOKEN: "/auth/refresh-token",
    GET_PERMISSION: "/auth/list-permission",
    GENERATE_SETUP_CODE_2FA: '/TwoFactorAuthenticator/generate-setupcode-2fa',
    CONFIRM_USING_2FA: '/TwoFactorAuthenticator/confirm-using-2fa',
    VALIDATE_2FA: '/TwoFactorAuthenticator/validate-login-2fa',
    // Phase 5b-2: provisioning thiết bị 2FA đa-thiết-bị.
    REGISTER_DEVICE: '/TwoFactorAuthenticator/register-device',
    CONFIRM_DEVICE: '/TwoFactorAuthenticator/confirm-device',
    LIST_DEVICE: '/TwoFactorAuthenticator/list-device',
    // GAP 7.4 UC7.4: đặt thiết bị Active làm thiết bị chính (invariant đúng-1-primary/user).
    SET_PRIMARY: '/TwoFactorAuthenticator/set-primary',
    // Phase 10 UC12: admin khoá/mở + xem thiết bị OTP của user khác.
    LOCK_DEVICE: '/TwoFactorAuthenticator/lock-device',
    UNLOCK_DEVICE: '/TwoFactorAuthenticator/unlock-device',
    LIST_DEVICE_BY_USER: '/TwoFactorAuthenticator/list-device-by-user',
    // UC7.5 hủy 1 thiết bị (soft-state) + UC10.4 kích hoạt lại tài khoản đã vô hiệu (atomic).
    REVOKE_DEVICE: '/TwoFactorAuthenticator/revoke-device',
    REACTIVATE_2FA: '/TwoFactorAuthenticator/reactivate-2fa',
    // OFF 2FA per-user (Approach A - 2026-08-11): admin QTHT vô hiệu/bật lại 2FA cho user cụ thể (step-up).
    DISABLE_2FA: '/TwoFactorAuthenticator/disable-2fa',
    ENABLE_2FA: '/TwoFactorAuthenticator/enable-2fa',
    // Phase 7B-1 UC13: cấu hình bảo mật OTP (admin).
    OTP_CONFIG: '/OtpConfig',
    // Phase 7C UC11: cấp mã kích hoạt (admin) + verify (user).
    OTP_ACTIVATION_ISSUE: '/OtpActivation/issue',
    OTP_ACTIVATION_VERIFY: '/OtpActivation/verify',
    // Phase 9b UC6: user tự cấp mã cho email đã xác nhận của mình (self-service, không cần role admin).
    OTP_ACTIVATION_REQUEST: '/OtpActivation/request',
    // Phase 8 UC17: nhật ký OTP (search + export).
    OTP_AUDIT_SEARCH: '/OtpAudit/search',
    OTP_AUDIT_EXPORT: '/OtpAudit/export',
    // GAP 17.1 INFO: catalog Reason/Group/Prefix (single source of truth ở BE, FE tiêu thụ read-only).
    OTP_AUDIT_REASON_CATALOG: '/OtpAudit/reason-catalog',
    // Phase 07 (Push Approval login-web): poll trạng thái attempt duyệt qua app + mint token đầy đủ.
    POLL_LOGIN_APPROVAL: '/TwoFactorAuthenticator/poll-login-approval',
    COMPLETE_LOGIN: '/TwoFactorAuthenticator/complete-login',
    // P2 QR handoff: 3 endpoint web-phiên (direct common-be, token stage-1 scheme 2FA,Bearer).
    MINT_ENROLL_TICKET: '/TwoFactorAuthenticator/mint-enroll-ticket',
    GET_PENDING_ENROLL: '/TwoFactorAuthenticator/get-pending-enroll',
    CONFIRM_ENROLL_BINDING: '/TwoFactorAuthenticator/confirm-enroll-binding',
    // UC7.4 port QTHT: thêm thiết bị dự phòng post-login (gate OTP thiết bị cũ -> mint ticket "authorized").
    // Bearer-only (token QTHT đầy đủ, giống set-primary). get-pending + confirm-binding tái dùng ở trên.
    MINT_ADD_DEVICE_TICKET: '/TwoFactorAuthenticator/mint-add-device-ticket',
    // UC14 Phase 2: cau hinh step-up theo chuc nang (KySo/PheDuyet/ThuHoi/CapQuyen) + lich su thay doi.
    STEP_UP_POLICIES: '/StepUp/policies',
    STEP_UP_POLICY_HISTORY: '/StepUp/policy-history',
  },
  CAN_BO: {
    SEARCH: "/CanBo/search",
    UPLOAD: "/CanBo/upload",
    CRUD: "/CanBo",
    ADD_OR_SAVE: "/CanBo/add-or-update",
    MENU: "/CanBoMenu",
    USER: "/CanBo/can-bo-users",
    LIST: "/CanBo/get-user-dang-nhap",
    CHECK_EXIST: "/CanBo/check-username",
    LIST_PHAN_QUYEN: "/CanBo/list-can-bo-phan-quyen",
    GET_THONG_TIN_USER: '/auth/get-canbo-user-info',
    GET_IMAGE_USER: '/FileObject/download-ftp',
    TRU_SO: 'CanBo/get-danh-sach-tru-so'
  },
  // Đơn vị
  DON_VI: {
    DANH_SACH_DON_VI_CHA: "/DonVi/all-by-don-vi-cha?soCap=999&isGetAll=true",
    DANH_SACH_DON_VI_CON_LAY_ID_THEO_CHA: "/DonVi/all-by-don-vi-cha",
    DANH_SACH_CAN_BO_TRUC_THUOC: "/CanBo/search",
    TAO_DON_VI: "/DonVi",
    XOA_DON_VI: "/DonVi",
    SUA_DON_VI: "/DonVi",
    DANH_SACH_CAN_BO: "/CanBo/list-canbo-khong-co-donvi",
    THEM_CAN_BO_TRUC_THUOC: "/CanBo/add-canbo-tructhuoc",
    XOA_CAN_BO: "/CanBo/remove-canbo-tructhuoc",
    CAP_NHAT_KHOA_CAN_BO: "CanBo/set-lock",

    ALL: "/DonVi/all",
    SEARCH: "/DonVi/search",
    TREE: "/DonVi/list-tree",
    CRUD: "/DonVi",
    CHILDREN: "/DonVi/all-by-don-vi-cha",
    ORDER: "/DonVi/update-order",
    GET_PHAM_VI: "/DonVi/list_donvi_cha",
    LAY_THU_TU_MAC_DINH: "/DonVi/lay-thu-tu-mac-dinh"
  },
  THONG_BAO_CUSTOM: {
    CRUD: "/CustomNotification",
    SEARCH: "/CustomNotification/search"
  },
  CHUC_VU: {
    ALL: "/ChucVu/all",
    SEARCH: "/ChucVu/search",
    ORDER: "/ChucVu/update-order",
    CRUD: "/ChucVu"
  },
  NHOM_CHUC_VU: {
    ALL: "/NhomChucVu/all",
    ORDER: "/NhomChucVu/update-order",
    CRUD: "/NhomChucVu",
    SEARCH: "/NhomChucVu/search"
  },
  CAP_DON_VI: {
    ALL: "/CapDonVi/all",
    ORDER: "/CapDonVi/update-order",
    CRUD: "/CapDonVi",
    SEARCH: "/CapDonVi/search",
    LAY_THU_TU_MAC_DINH: "/CapDonVi/lay-thu-tu-mac-dinh"
  },
  DANH_MUC_HE_THONG: {
    ALL: "/DanhMucHeThong/all",
    ORDER: "/DanhMucHeThong/update-order",
    CRUD: "/DanhMucHeThong"
  },
  DANH_MUC_MENU_HE_THONG: {
    ALL: "/DanhMucMenuHeThong/all",
    TREE: "/DanhMucMenuHeThong/list-tree",
    ORDER: "/DanhMucMenuHeThong/update-order",
    CRUD: "/DanhMucMenuHeThong"
  },
  DANH_MUC_NHOM_MENU: {
    SEARCH: "/NhomQuyen/search",
    CRUD: "/NhomQuyen",
    USER: "/NhomQuyen/can-bo-nhom-quyen",
    PERMISSION: "/NhomQuyen/nhom-quyen-menu"
  },
  DANH_MUC_TINH_THANH: {
    SEARCH: "/DanhMuc/search-location",
    THEM: "/DanhMuc/add-location",
    XOA: "/DanhMuc/delete-location",
    SUA: "/DanhMuc/update-location",
    TINH_THANH_TRONG_VUNG: "/DanhMuc/tinh-thanh-trong-vung",
    TINH_THANH_FREE: "/DanhMuc/tinh-thanh-khong-trong-vung"
  },
  USER: {
    NAME: "/users",
    LAY_CHI_TIET_NGUOI_DUNG: "/users",
    // NGUOI_DUNG_GOM_QUYEN: "/users/search",
    NGUOI_DUNG_GOM_QUYEN: "/users/get-paging",
    CAP_NHAT_VAI_TRO_THEO_NGUOI_DUNG: "/users",
    CAP_NHAT_QUYEN_THEO_NGUOI_DUNG: "/users",
    CAP_NHAT_EMAIL_NGUOI_DUNG: "/users",

    CAP_NHAT_ACTIVE_NGUOI_DUNG: "/users/active_user",
    DANH_SACH_NGUOI_DUNG_THEO_GROUP: "/users/ingroup",
    DANH_SACH_NGUOI_DUNG_THEO_ROLE: "/users/inrole",
    DANH_SACH_NGUOI_DUNG_NOT_IN_GROUP: "/users/notingroup",
    DANH_SACH_NGUOI_DUNG_NOT_IN_ROLE: "/users/notinrole",
    TAO_MOI_NGUOI_DUNG: "/users/add",
    CAP_NHAT_NGUOI_DUNG: "/users/update",
    RESET_PASSWORD_NGUOI_DUNG: "/users/reset_password",
    XOA_NGUOI_DUNG: "/users?id=",
    DANH_SACH_VAI_TRO_THEO_NGUOI_DUNG: "/users/rolesbyuser",
    DANH_SACH_GROUP_THEO_NGUOI_DUNG: "/users/groupsbyuser",
    DANH_SACH_VAI_TRO_KHONG_THUOC_NGUOI_DUNG: "/users/roles_notuse_user",
    DANH_SACH_GROUP_KHONG_THUOC_NGUOI_DUNG: "/users/groups_notuse_user",
    ADD_MAPPING: "/users/add_mapping",
    REMOVE_MAPPING: "/users/remove_mapping",
    DANH_SACH_QUYEN_THEO_NGUOI_DUNG: "/users/permission_use",
    DANH_SACH_QUYEN_KHONG_THUOC_NGUOI_DUNG: "/users/permission_not_use",
    DANH_SACH_CAN_BO_LAY_VAO_NGUOI_DUNG: "/CanBo/list-canbo-khong-co-user",
    DANH_SACH_NGUOI_DUNG_NOT_IN_CAN_BO: "/users/notincanbo",
    CHANGE_PASSWORD: "/auth/change-pass",
    RESET_PASSWORD: "/users/reset_password",
    RESET_QR: "twoFactorAuthenticator/reset-setting-2fa",
  },
  PERMISSION: {
    DANH_SACH_TAT_CA_QUYEN: "/permissions/search",
    DANH_SACH_QUYEN_THEO_GROUP: "/Permission/listbygroup",
    DANH_SACH_QUYEN_KHONG_THUOC_GROUP: "/Permission/not-in-group",
    DANH_SACH_QUYEN_THEO_APP: "/Permission/list-by-app-paging",
    DANH_SACH_TAT_CA_QUYEN_THEO_APP: "/Permission/all-list-by-app",
    DANH_SACH_QUYEN_KHONG_THUOC_VAI_TRO: "/Permission/not-in-role",
    DANH_SACH_QUYEN_THEO_VAI_TRO: "/Permission/list-by-role",
    ADD_OR_UPDATE_OBJECT_PERMISSION:
      "/Permission/add-or-update-object-permissions",
    REMOVE_ITEM_OBJECT_PERMISSION: "/Permission/remove-object-permissions",
    ACTIVE_PERMISSION: "/Permission/active-permission",
    XOA_PHAM_VI_QUYEN: "/Permission/xoa-pham-vi-quyen",
    CONFIG_PHAM_VI_QUYEN: "/Permission/add-objects-to-permissions",
    XOA_ACTOR_MAPPING: "/permission/delete-actor-mapping"
  },
  LOG: {
    DANH_SACH_LOG_THEO_APP: "/systems"
  },
  ROLE: {
    DANH_SACH_QUYEN_THEO_VAI_TRO: "/roles",
    DANH_SACH_QUYEN_KHONG_THUOC_VAI_TRO: "/roles",
    NGUOI_DUNG_THEO_VAI_TRO: "/roles",
    NGUOI_DUNG_KHONG_THUOC_VAI_TRO: "/roles",
    THEM_NGUOI_DUNG_TRONG_VAI_TRO: "/roles",
    XOA_NGUOI_DUNG_TRONG_VAI_TRO: "/roles",
    DANH_SACH_VAI_TRO: "/roles/search",

    CAP_NHAT_THONG_TIN_VAI_TRO: "/role/update",
    XOA_VAI_TRO: "/role/delete",
    TAO_VAI_TRO: "/role/add",
    CHI_TIET_VAI_TRO: "/role/detail",
    DANH_SACH_VAI_TRO_THEO_APP: "/Role/search",
    DANH_SACH_VAI_TRO_THEO_GROUP: "/Role/listbygroup",
    DANH_SACH_VAI_TRO_KHONG_THUOC_GROUP: "/Role/not-in-group",
    CAP_NHAT_QUYEN_TRONG_VAI_TRO: "/Role/update-permission",
    CAP_NHAT_NGUOI_DUNG_TRONG_VAI_TRO: "/Role/update-user",
    // T4+5 UC13.3: đếm user exempt bị ảnh hưởng khi bật mandate OTP cho vai trò (modal confirm).
    AFFECTED_OTP_USERS: "/role/affected-otp-users"
  },
  THONG_BAO: {
    TAO_THONG_BAO: "/News",
    CAP_NHAT_THONG_BAO: "/News",
    GET_CHI_TIET_THONG_BAO: "/News/getById",
    XOA_THONG_BAO: "/News",
    DUYET_THONG_BAO: "/News/approve",
    GUI_DUYET_THONG_BAO: "/News/submit",
    DANG_THONG_BAO: "/News/publish",
    TU_CHOI_DUYET_THONG_BAO: "/News/reject",
    DONG_MO_THONG_BAO: "/News/changeStatus",
    DANH_SACH_QUAN_LY_THONG_BAO: "/News/getPaging",
    GET_TAT_CA_DANH_MUC: "/NewsCategories/getAll",
    GET_TAT_CA_DANH_MUC_THEO_PAGING: "/NewsCategories/getPaging",
    GET_TAT_CA_NGUON_NHAN_THONG_BAO: "/NewsTypes/getAll",
    GET_CHI_TIET_DANH_MUC: "/NewsCategories/getById",
    LICH_SU_THAO_TAC: "NewsLogs/getAllByNewsId"
  },
  LICH_LAM_VIEC: {
    GET_TAT_CA_LOAI_LICH_LAM_VIEC: "/ScheduleTypes/getAll",
    GET_CHI_TIET_LOAI_LICH_LAM_VIEC: "/ScheduleTypes/getById",
    TAO_LICH_LAM_VIEC: "/Schedules",
    LAY_LICH_LAM_VIEC: "/Schedules",
    CAP_NHAT_LICH_LAM_VIEC: "/Schedules",
    GET_CHI_TIET_LICH_LAM_VIEC: "/Schedules",
    XOA_LICH_LAM_VIEC: "/Schedules/",
    GET_DANH_SACH_LICH_LAM_VIEC: "/Schedules",
    SUA_LICH_LAM_VIEC: "/Schedules",
    XUAT_LICH_LAM_VIEC: "/Schedules/exportdata",
    TREE: "/Schedules/list-tree",
    CHILDREN: "/ScheduleTypes/getByParrentId"
  },
  QUAN_TRI_HE_THONG: {
    QUAN_TRI_THONG_BAO_LOAI: "/NewsCategories/getPaging",
    QUAN_TRI_THONG_BAO_NGUON: "/NewsTypes/getPaging",
    THEM_SUA_LOAI: "/NewsCategories",
    XOA_LOAI: "/NewsCategories/",
    THEM_SUA_NGUON: "/NewsTypes",
    XOA_NGUON: "/NewsTypes/"
  },
  APP: {
    SYNC_DATA: "/SyncData/sync",
    ALL: "/App/all",
    SEARCH: "/App/search",
    ADD: "/App/add",
    UPDATE: "/App/update",
    DELETE: "/App/delete",
    ORDER: "/App/update-order",
    UPDATE_STATUS: "/App/update-status",
    LIST_APP: "Users/list-application"
  },
  GROUP: {
    ALL: "/Group/all",
    SEARCH: "/Group/search",
    ADD: "/Group/add",
    DETAIL: "/Group/detail",
    UPDATE: "Group/update",
    CAP_NHAT_QUYEN_TRONG_GROUP: "Group/permissions",
    ADD_MAPPING: "Group/add_mapping",
    REMOVE_MAPPING: "Group/remove_mapping",
    DELETE: "Group/Delete",
    // T4+5 UC13.4: đếm user exempt bị ảnh hưởng khi bật mandate OTP cho nhóm (modal confirm).
    AFFECTED_OTP_USERS: "Group/affected-otp-users"
  },
  IMPORT: {
    CAP_DON_VI: "/Import/cap-don-vi",
    NHOM_CHUC_VU: "/Import/nhom-chuc-vu",
    CHUC_VU: "/Import/chuc-vu",
    DON_VI: "/Import/don-vi",
    CAN_BO_USER: "/Import/can-bo-user",
    MULTI: "/Import/multi"
  },
  DANH_MUC: {
    TINH_THANH: "/DanhMuc/tinh-thanh",
    LEVEL: "Permission/level-permission"
  }
};
